export const text = {
  HEIGHT_FT: 'Height (ft)',
  HEIGHT_FT_LOWER: 'height (ft)',
  HEIGHT_IN: 'Height (in)',
  BODY_MEASUREMENTS: 'Body measurements',
  IDENTITY: 'Identity',
  ASTERISK_TEXT: '*',
  WEIGHT_TEXT: 'Weight (lbs)',
  MARITAL_STATUS: 'Marital status',
  RACIAL_BACKGROUND: 'Racial background',
  SEX_AT_BIRTH: 'Sex at birth',
  GENDER_IDENTITY: 'Gender identity',
}

export const HEIGHT_FT_OPTIONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9']
export const HEIGHT_IN_OPTIONS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']
export const MARITAL_STATUS_OPTIONS = [
  'Annulled',
  'Divorced',
  'Legally separated',
  'Married',
  'Polygamous',
  'Never married',
  'Domestic partner',
  'Single',
  'Widowed',
  'Prefer not to say',
]
export const RACIAL_BACKGROUND_OPTIONS = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Caucasian',
  'Hispanic or Latino',
  'Native Hawaiian or other Pacific Islander',
  'Prefer not to say',
]
